<template>
	<page style="background: #fff;">
		<c-form ref="form">
			<c-form-item label="盘点单号">
				<c-input name="check_code" placeholder="请输入，忽略则自动生成"></c-input>
			</c-form-item>
			<c-form-item label="盘点部门" required>
				<c-select v-model="checkDepartment" name="dept_id" async @search="searchDepartment"></c-select>
			</c-form-item>
			<c-form-item label="盘点人员" required>
				<c-select ref="userSelect" name="check_user_id" :placeholder="!checkDepartment ? '请先选择盘点部门' : '请选择'" :disabled="!checkDepartment" async @search="searchUser"></c-select>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button color="main" hollow size="form" @click="mp.navigateBack()">取消</c-button>
			<c-button class="foot-button" size="form" color="main" @click="submitHandle">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				checkDepartment: ''
			}
		},

		watch: {
			checkDepartment(val) {
				if (!val) {
					this.$refs.userSelect.set();
				}
			}
		},
		
		methods: {
			searchDepartment(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'DEPARTMENT',
						keyword
					},
					success: resolve
				})
			},

			searchUser(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'SYSUSER',
						department_id: this.checkDepartment,
						keyword
					},
					success: resolve
				})
			},

			submitHandle() {
				this.$refs.form.submit({
					url: '/inventory/create',
					rule: {
						dept_id: '请选择盘点部门',
						check_user_id: '请选择盘点人员'
					},
					success: () => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						this.mp.navigateBack(true);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>